import React, { PropsWithChildren, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './Tagfeed.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';
import { TArticlePagination } from '../../types/shared/Pagination';
import { useWidthContext } from '../../providers/Width';
import { Article } from '../../types/shared/Article';
import { shortenText } from '../../utils/cob-utils';
import { Row, Col, PhotoCard } from '../../importCL';
import Pagination from '../Pagination/Pagination';

interface ITagfeedProps extends MappedComponentProperties {
    title?: string;
}

export const TagfeedEditConfig = {
    emptyLabel: 'Tagfeed',
    isEmpty: (props: PropsWithChildren<ITagfeedProps>) => {
        const isMetaDataAvailable = !!JSON.parse(
            PathUtils.getMetaPropertyValue('articleFeedData') || '{}',
        ).topArticles;

        return !props || !isMetaDataAvailable;
    },
};

const Tagfeed = (props: PropsWithChildren<ITagfeedProps>): JSX.Element => {
    const { width } = useWidthContext();
    const authorFeed = props.cqPath.includes('articles/author');
    const isMobile = width <= 768;
    const parsedMetadata = JSON.parse(PathUtils.getMetaPropertyValue('articleFeedData') || '{}');

    const [page] = useState<TArticlePagination>({
        pageNumber: authorFeed && isMobile ? parsedMetadata.currentPageNumberMobile : parsedMetadata.currentPageNumber,
        lastPageNumber: authorFeed && isMobile ? parsedMetadata.lastPageNumberMobile : parsedMetadata.lastPageNumber,
        topArticles: authorFeed && isMobile ? parsedMetadata.authorArticlesMobile : parsedMetadata.topArticles,
        bottomArticles: parsedMetadata.bottomArticles,
        baseUrl: parsedMetadata.baseUrl,
    });

    return (
        <div id='tag-feed' className='TagFeed'>
            {props.title && (
                <Row>
                    <Col><h4 className='text-grey-tundora font-xl mb-6'>{transformHTMLParserLinks(props.title)}</h4></Col>
                </Row>
            )}
            <Row>
                {page && page.topArticles && page.topArticles.map((article: Article, index: number) => {
                    return (<Col md={4} xs={12} key={index} className='d-flex justify-content-center'>
                        <PhotoCard titleTag='h4' tagClass='border border-solid border-grey-silver h-full' className='TagFeed__photoCard' anchorText='Read more' showAnchorMobile shadowless truncateTitle cardContent={{
                            helperHeader: new Date(article.date).toDateString(),
                            title: `${article.title}`,
                            description: `${shortenText(article.previewDescription as string)}`,
                            image: `${article.imagePath  + '?imwidth=360'}`,
                            imageAltText: `${article.imageAlt}`,
                            link: `${article.pagePath}${props.isInEditor ? '.html' : ''}`,
                            target: '_self',
                        }} />
                    </Col>);
                })}
            </Row>
            {(!authorFeed || authorFeed && !isMobile) &&
                <Row className='TagFeed__bottomRow'>
                    {page && page.bottomArticles && page.bottomArticles.map((article: Article, index: number) =>
                        <Col md={4} xs={12} key={index} className='d-flex justify-content-center'>
                            <PhotoCard titleTag='h4' tagClass='border border-solid border-[#BEBEBE] h-full' className='TagFeed__photoCard mb-4' anchorText='Read more' showAnchorMobile shadowless truncateTitle cardContent={{
                                helperHeader: new Date(article.date).toDateString(),
                                title: `${article.title}`,
                                description: `${shortenText(article.previewDescription as string)}`,
                                image: `${article.imagePath + '?imwidth=360'}`,
                                imageAltText: `${article.imageAlt}`,
                                link: `${article.pagePath}`,
                                target: '_self',
                            }} />
                        </Col>)
                    }
                </Row>
            }
            <Pagination {...page} />
        </div>
    );
};

export default Tagfeed;

